module.exports = __webpack_public_path__ + "img/ai-service.627e212a.svg";